import dayjs from 'dayjs';

import { lsPrefix } from '@ll-platform/frontend/consts/globals';
import { lemonlightOrganizationId } from '@ll-platform/shared-domain/const';

export const organizationIdLsKey = `${lsPrefix}OrganizationId`;
export const organizationBackdoorLsKey = `${lsPrefix}OrganizationOverride`;
export const organizationSessionStorageInitializedLsKey = `${lsPrefix}OrganizationSessionStorageInitialized`;

export const organizationHttpHeader = 'X-HERO-Organization-ID';

// Temporary for backward compatiblity with feature flag
export const lemonlightDefaultOrganization = {
  id: lemonlightOrganizationId,
  name: 'Lemonlight',
  createdAt: dayjs(),
  updatedAt: dayjs(),
};

export const fallbackOrganizationName = 'Lemonlight';
